import React, { useState, useEffect } from 'react';
import { browserHistory, Link } from 'react-router';
import { UserAssets, UserOwners, UserProfile, UserRoles } from '../components'
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { Paper, Tab, Tabs } from '@material-ui/core';
import { SettingsNavWrapper } from '../../elements'
import { globalGetService } from '../../../globalServices';
import { checkApiStatus, checkPermission } from '../../utils_v2';
import { jetStreamInstance } from '../../../shared/components';
import { trackActivity } from '../../../utils/mixpanel';
const UserDetail = ({params}) => {
    const [tabIndex, setTabIndex] = useState(0);
    const [userInfo, setUserInfo] = useState({});
    useEffect(() => {
        getUserDetail();
        trackActivity('Console Management', { page_title: 'User Detail', event_type: 'Page Visit', event_desc: 'User Detail Page Visited' })
    },[]);
    const getUserDetail = () => {
        globalGetService(`console/get-user-details/${params.slug}/`,{lite:true})
        .then(response => {
            if(checkApiStatus(response)){
                setUserInfo(response.data.data)
            }else{
                browserHistory.push('/users/manage')
            }
        })
    }
    return(
        <section className='roles-management asset-tech-specs' style={{margin:'25px 0 0 75px'}}>
            <Paper elevation={0} className='tech-specs-card console-paper' style={{minHeight: `${window.innerHeight - 89}px`}}>
            <SettingsNavWrapper />
            <div className='tech-specs-content' style={{padding: '10px'}}>
            <div><Link style={{cursor:'pointer'}} className='flex-centered' to={'/users/manage'}> <ArrowBackIcon fontSize='small' color='primary'/> <span style={{color:'#3f51b5'}}>User(s)</span></Link></div>
            <Paper style={{marginBottom:'15px', padding:'10px'}}>
                <UserProfile 
                    params={params} 
                    profileType='userProfile'
                />
            </Paper>
            <Paper style={{marginBottom:'15px'}}>
                <Tabs indicatorColor='primary' value={tabIndex} onChange={(event, newValue) => setTabIndex(newValue)}>
                    <Tab label="Role(s)"/>
                    <Tab label="Allowed Asset(s)"/>
                    <Tab label={`Allowed ${jetStreamInstance?"Owner/SPV":"Owner"}(s)`}/>
                </Tabs>
            </Paper>
            { tabIndex === 0 ?
                <div>
                    <UserRoles 
                        params={params} 
                        userInfo={userInfo}
                    />
                </div>:null
            }
            { tabIndex === 1 ?
                <div>
                    <UserAssets 
                        userInfo={userInfo}
                    />
                </div>:null
            }    
            { tabIndex === 2 ?
                <div>
                    <UserOwners 
                        userInfo={userInfo}
                    />
                </div>:null
            }    
            </div>
            </Paper>
        </section>
    )
}
export default UserDetail;